import { LOCATION_SIDEBAR } from './locationSidebar';

export const CREATE_LOCATION_TEMPLATE = `
<div class="flex min-h-screen">
<!-- Sidebar Navigation -->
${LOCATION_SIDEBAR}
<!-- Main Content Area -->
<main class="ml-64 flex-1 flex flex-col min-w-0 bg-background-light dark:bg-background-dark">
<!-- Top Header -->
<header class="h-16 border-b border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md sticky top-0 z-[1200] flex items-center justify-between px-8">
<div class="flex items-center gap-4">
<nav aria-label="Breadcrumb" class="flex text-sm text-slate-500 dark:text-slate-400">
<ol class="flex items-center space-x-2">
<li><a class="hover:text-primary" href="/locations">Locations</a></li>
<li class="flex items-center space-x-2">
<span class="material-symbols-outlined text-sm">chevron_right</span>
<span class="text-slate-900 dark:text-white font-medium">New Location</span>
</li>
</ol>
</nav>
</div>
<div class="flex items-center gap-3">
<button id="create-location-cancel-btn" class="px-4 py-2 text-sm font-semibold text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors" type="button">Cancel</button>
<button id="create-location-suggest-btn" class="px-4 py-2 text-sm font-semibold text-slate-900 dark:text-white bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 rounded-lg transition-colors" type="button">Submit Suggestion</button>
<button id="create-location-save-draft-btn" class="px-4 py-2 text-sm font-semibold text-slate-900 dark:text-white bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 rounded-lg transition-colors" type="button">Save Draft</button>
<button id="create-location-publish-btn" class="px-4 py-2 text-sm font-semibold text-white bg-primary hover:bg-blue-600 rounded-lg shadow-sm shadow-primary/20 transition-colors" type="button">Publish Location</button>
</div>
</header>
<!-- Form Content -->
<div class="p-8 max-w-6xl mx-auto w-full grid grid-cols-1 lg:grid-cols-3 gap-8">
<!-- Main Form Column -->
<div class="lg:col-span-2 space-y-6">
<!-- Basic Info Section -->
<section class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-6 shadow-sm">
<h2 class="text-lg font-bold mb-6">General Information</h2>
<div class="space-y-4">
<div>
<label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Location Title</label>
<div class="flex items-center gap-2">
<input id="create-location-title" class="flex-1 max-w-[72%] bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg focus:ring-primary focus:border-primary px-4 py-2.5" placeholder="e.g. Transfăgărășan Pass" type="text"/>
<button id="create-location-import-btn" class="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-bold text-slate-700 hover:text-slate-900 transition-colors bg-slate-100 rounded-md border border-slate-300 whitespace-nowrap" type="button">
<span class="material-symbols-outlined text-sm">upload_file</span>
Import JSON
</button>
<button id="create-location-ai-btn" class="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-bold text-primary hover:text-blue-600 transition-colors bg-primary/5 rounded-md border border-primary/20 whitespace-nowrap" type="button">
<span class="material-symbols-outlined text-sm">auto_awesome</span>
Generate with AI
</button>
</div>
</div>
<div>
<label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Slug</label>
<div class="flex items-center">
<span id="create-location-slug-prefix" class="bg-slate-100 dark:bg-slate-700 px-3 py-2.5 rounded-l-lg border border-r-0 border-slate-200 dark:border-slate-700 text-slate-500 text-sm">https://motojourney.by/locations/</span>
<input id="create-location-slug" class="flex-1 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-r-lg focus:ring-primary focus:border-primary px-4 py-2.5 text-sm" placeholder="transfagarasan-pass" type="text"/>
</div>
</div>
<div>
<label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Description</label>
<div id="create-location-content-blocks-editor" class="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-3"></div>
<textarea id="create-location-content-blocks" class="hidden" rows="1"></textarea>
</div>
<div>
<label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Fallback Description</label>
<textarea id="create-location-description" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg focus:ring-primary focus:border-primary px-4 py-2.5" placeholder="Text fallback for clients without blocks support..." rows="6"></textarea>
</div>
</div>
</section>
<!-- Media Section -->
<section class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-6 shadow-sm">
<h2 class="text-lg font-bold mb-6">Media Gallery</h2>
<div class="mb-6 rounded-xl border border-slate-200 dark:border-slate-700 p-4 bg-slate-50/60 dark:bg-slate-800/30">
<div class="flex items-center justify-between gap-3 mb-3">
<div>
<h3 class="text-sm font-bold text-slate-900 dark:text-white">Cover Image</h3>
<p class="text-xs text-slate-500">Main preview image for location cards.</p>
</div>
<button id="create-location-cover-btn" class="px-3 py-2 text-xs font-bold bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg hover:bg-slate-50 transition-colors" type="button">Select Cover</button>
<input id="create-location-cover-input" class="hidden" type="file" accept="image/*"/>
</div>
<p id="create-location-cover-name" class="text-xs text-slate-500 mb-3"></p>
<div id="create-location-cover-preview" class="aspect-[16/9] w-full max-w-xl rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700 bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-xs text-slate-400">
No cover selected
</div>
</div>
<div class="border-2 border-dashed border-slate-200 dark:border-slate-700 rounded-xl p-8 text-center bg-slate-50/50 dark:bg-slate-800/30">
<div class="mx-auto size-12 bg-primary/10 rounded-full flex items-center justify-center text-primary mb-4">
<span class="material-symbols-outlined text-2xl">upload_file</span>
</div>
<h3 class="text-sm font-bold text-slate-900 dark:text-white">Click to upload or drag and drop</h3>
<p class="text-xs text-slate-500 mt-1">High-resolution JPEG or PNG up to 10MB</p>
<button id="create-location-media-btn" class="mt-4 px-4 py-2 text-xs font-bold bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg hover:bg-slate-50 transition-colors" type="button">Select Files</button>
<input id="create-location-media-input" class="hidden" type="file" accept="image/*" multiple/>
</div>
<div id="create-location-media-preview" class="grid grid-cols-4 gap-4 mt-6">
<div class="relative aspect-video rounded-lg overflow-hidden group">
<img class="w-full h-full object-cover" data-alt="Mountain motorcycle road preview" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCjg_rnzIhoeSB3mrqhED1cv55LrMSg6Ado4SvwErFm3eesw3A2m59JmVIWovS_GbohUzmmJ_ItaYoP2ZzUZgOMtCtHM1DgQSP3raPnLSb4VCbPLB9hwWAX1U1sgM-o0msm37AMZdvdl5BQNdhJ8Es46PGVE-93zfkCEIioKBK5Ohmvm5ecsFvTV6aUxjcQrjMqppAVN7qvK4DAZcD0kxfBzzMpZNxQsHRzP6HYaQPgym9iMCvQwvmCC4DjtqkQ4wwOx3BecZEyUB8b"/>
<button class="absolute top-1 right-1 size-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
<span class="material-symbols-outlined text-xs">close</span>
</button>
</div>
<div class="relative aspect-video rounded-lg overflow-hidden group">
<img class="w-full h-full object-cover" data-alt="Coastal road landscape" src="https://lh3.googleusercontent.com/aida-public/AB6AXuDUQHZH6b0zDdlwscGiNvVPn6CbcZwrHWgeIEvV8g112B-nk6xnWNMa_bppZilM3xd4eWjI3_FltXfbO3UEvAwcBdRar7EL1fMpJg3e7Vw5iBPjOv3d6GB3OCWA0ni3v00RzIqCAg9HwDqGnPnomYemJdxJQ7iOZL1bEKJIalxo3fa29T0nKW3ZggAKVzSSKhXIEdMtlr4jRLwEb3xk0_jmfspvETsFjroma4aKQ5xc2_TkIjWENJDMhBGNl1P6VmLCvBSOoStTi8-R"/>
<button class="absolute top-1 right-1 size-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
<span class="material-symbols-outlined text-xs">close</span>
</button>
</div>
<div class="aspect-video rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 flex items-center justify-center cursor-pointer hover:bg-slate-100 transition-colors border-dashed">
<span class="material-symbols-outlined text-slate-400">add</span>
</div>
</div>
</section>
<!-- Facts Section -->
<section class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-6 shadow-sm">
<h2 class="text-lg font-bold mb-6">Quick Facts</h2>
<div class="grid grid-cols-1 md:grid-cols-3 gap-6">
<div>
<label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Road Type</label>
<select id="create-location-road-type" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg focus:ring-primary focus:border-primary px-4 py-2.5 text-sm">
<option value="">Select road type</option>
</select>
</div>
<div>
<label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Difficulty</label>
<select id="create-location-difficulty" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg focus:ring-primary focus:border-primary px-4 py-2.5 text-sm">
<option value="">Select difficulty</option>
</select>
</div>
<div>
<label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Best Season</label>
<select id="create-location-best-season" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg focus:ring-primary focus:border-primary px-4 py-2.5 text-sm">
<option value="">Select best season</option>
</select>
</div>
</div>
<div class="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
<div>
<label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Safety Notes</label>
<textarea id="create-location-safety-notes" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg focus:ring-primary focus:border-primary px-4 py-2.5 text-sm" rows="3" placeholder="Road hazards, weather warnings, emergency notes..."></textarea>
</div>
<div>
<label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Access Rules</label>
<textarea id="create-location-access-rules" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg focus:ring-primary focus:border-primary px-4 py-2.5 text-sm" rows="3" placeholder="Paid entry, opening hours, permit requirements..."></textarea>
</div>
</div>
<div class="mt-6">
<div class="flex items-center justify-between mb-2">
<label class="block text-sm font-semibold text-slate-700 dark:text-slate-300">Additional Facts</label>
<button id="create-location-add-fact-btn" class="px-2 py-1 border border-slate-200 text-slate-600 text-xs rounded-md hover:bg-slate-50" type="button">+ Add Fact</button>
</div>
<div id="create-location-facts-list" class="space-y-2"></div>
</div>
</section>
</div>
<!-- Side Panel Column -->
<div class="space-y-6">
<!-- Status & Feature Section -->
<section class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-6 shadow-sm">
<div class="flex items-center justify-between mb-4">
<span class="text-sm font-semibold text-slate-700 dark:text-slate-300">Featured Location</span>
<button id="create-location-featured-toggle" class="relative inline-flex h-6 w-11 items-center rounded-full bg-primary" type="button">
<span class="sr-only">Toggle Featured</span>
<span class="inline-block h-4 w-4 translate-x-6 transform rounded-full bg-white transition"></span>
</button>
</div>
<p class="text-xs text-slate-500 mb-6">Featured locations appear on the homepage and at the top of search results.</p>
<hr class="border-slate-100 dark:border-slate-800 mb-4"/>
<div class="space-y-3">
<div class="flex items-center justify-between text-xs">
<span class="text-slate-500">Status</span>
<span id="create-location-status-badge" class="px-2 py-0.5 bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full font-bold">Draft</span>
</div>
<div class="flex items-center justify-between text-xs">
<span class="text-slate-500">Last Modified</span>
<span id="create-location-last-modified" class="text-slate-900 dark:text-white font-medium">just now</span>
</div>
</div>
</section>
<!-- Geographical Data -->
<section class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-6 shadow-sm">
<h2 class="text-sm font-bold mb-4 uppercase tracking-wider text-slate-400">Geographic Data</h2>
<div class="space-y-4">
<div class="grid grid-cols-2 gap-3">
<div>
<label class="block text-xs font-semibold text-slate-500 mb-1">Latitude</label>
<input id="create-location-latitude" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-3 py-2" placeholder="45.5912" type="text"/>
</div>
<div>
<label class="block text-xs font-semibold text-slate-500 mb-1">Longitude</label>
<input id="create-location-longitude" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-3 py-2" placeholder="24.6212" type="text"/>
</div>
</div>
<div>
<label class="block text-xs font-semibold text-slate-500 mb-1">Country</label>
<select id="create-location-country" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-3 py-2">
<option>Romania</option>
<option>Italy</option>
<option>Switzerland</option>
<option>USA</option>
</select>
</div>
<div>
<label class="block text-xs font-semibold text-slate-500 mb-1">Region</label>
<select id="create-location-region" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-3 py-2">
<option>Transylvania</option>
<option>Dolomites</option>
<option>California</option>
</select>
</div>
<div>
<label class="block text-xs font-semibold text-slate-500 mb-1">County</label>
<select id="create-location-county" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-3 py-2">
<option value="">Select county</option>
</select>
</div>
<div>
<label class="block text-xs font-semibold text-slate-500 mb-1">Settlement</label>
<select id="create-location-settlement" class="w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-3 py-2">
<option value="">Select settlement</option>
</select>
</div>
<div id="create-location-map" class="h-40 rounded-lg bg-slate-100 dark:bg-slate-800 overflow-hidden border border-slate-200 dark:border-slate-700 relative">
<div id="create-location-map-placeholder" class="absolute inset-0 flex items-center justify-center bg-slate-100 text-center z-10 pointer-events-none">
<div>
<span class="material-symbols-outlined text-slate-400 text-3xl mb-1">map</span>
<p class="text-[10px] text-slate-500 uppercase tracking-widest">Interactive Preview</p>
</div>
</div>
</div>
</div>
</section>
<!-- Categories & Tags -->
<section class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-6 shadow-sm">
<h2 class="text-sm font-bold mb-4 uppercase tracking-wider text-slate-400">Classification</h2>
<div class="space-y-4">
<div>
<label class="block text-xs font-semibold text-slate-500 mb-2">Categories</label>
<div class="flex gap-2 mb-2">
<select id="create-location-category-select" class="flex-1 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-3 py-2">
<option value="">Select category</option>
</select>
<button id="create-location-category-add-btn" class="px-2 py-1 border border-slate-200 dark:border-slate-700 text-slate-500 text-xs rounded-md hover:bg-slate-50" type="button">+ Add</button>
</div>
<div id="create-location-categories-selected" class="flex flex-wrap gap-2"></div>
</div>
<div>
<label class="block text-xs font-semibold text-slate-500 mb-1">Tags</label>
<div class="flex gap-2 mb-2">
<select id="create-location-tag-select" class="flex-1 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-3 py-2">
<option value="">Select tag</option>
</select>
<button id="create-location-tag-add-btn" class="px-2 py-1 border border-slate-200 dark:border-slate-700 text-slate-500 text-xs rounded-md hover:bg-slate-50" type="button">+ Add</button>
</div>
<div id="create-location-tags-selected" class="mt-3 flex flex-wrap gap-1.5"></div>
</div>
</div>
</section>
</div>
</div>
<!-- Sticky Footer for Actions (Mobile View) -->
<div class="lg:hidden sticky bottom-0 border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-4 flex gap-3">
<button class="flex-1 px-4 py-2.5 text-sm font-semibold text-slate-900 dark:text-white bg-slate-100 dark:bg-slate-800 rounded-lg">Save Draft</button>
<button class="flex-1 px-4 py-2.5 text-sm font-semibold text-white bg-primary rounded-lg shadow-sm">Publish</button>
</div>
</main>
</div>
`;
